/**
 * Dry dock raporları, denetim izi ve filo görünümü metinleri (ADR 0129 Ek Faz 5). Ortağın Excel'indeki
 * durum adları İngilizcede aynen (Approved, In Progress, Completed, Verified, Closed, Pending).
 */

export const drydockReportEn = {
  pdiTitle: 'Pre-Docking Inspection Report',
  afterTitle: 'After Docking Inspection Report',
  jobListTitle: 'Yard Job List',
  closeoutTitle: 'Dry Dock Closeout Report',
  marks: {
    provisional: 'INSPECTION OPEN – PROVISIONAL',
    cancelled: 'CANCELLED',
    notApproved: 'NOT APPROVED',
    containsNotApproved: 'CONTAINS JOBS NOT APPROVED',
    preview: 'PREVIEW – PROJECT NOT CLOSED',
  },
  sections: {
    general: 'General Information',
    summary: 'Summary',
    results: 'Checkpoint Results',
    measurements: 'Measurements',
    corrections: 'Corrections (revisions)',
    findings: 'Findings',
    attachments: 'Evidence',
    jobs: 'Jobs',
    cancelledJobs: 'Cancelled Jobs',
    inspections: 'Inspections',
    pending: 'Pending and Carried Jobs',
    openFindings: 'Findings Not Closed',
    plan: 'Closeout Preview',
    review: 'Review',
    approval: 'Office Approval',
    verification: 'Office Verification',
  },
  fields: {
    vessel: 'Vessel',
    project: 'Project',
    inspection: 'Inspection',
    kind: 'Type',
    openedOn: 'Opened',
    closedOn: 'Closed',
    library: 'Library version',
    status: 'Status',
    applicable: 'Applicable',
    inspected: 'Inspected',
    remaining: 'Remaining',
    adverse: 'Adverse',
    deferred: 'After Docking',
    notApplicable: 'Not applicable',
    progress: 'Progress',
    yard: 'Yard',
    dockedOn: 'Docked',
    undockedOn: 'Undocked',
    closeNote: 'Closing note',
    jobs: 'Jobs',
    approvedJobs: 'Approved',
    findings: 'Findings',
    closedFindings: 'Findings closed',
    closedJobs: 'Jobs closed',
    pendingJobs: 'Jobs pending',
    verifiedJobs: 'Jobs verified',
  },
  columns: {
    code: 'ID',
    checkpoint: 'Checkpoint',
    result: 'Result',
    access: 'Access',
    inspector: 'Inspector',
    inspected: 'Inspected',
    revision: 'Rev.',
    review: 'Review',
    measurement: 'Measurement',
    value: 'Value',
    lower: 'Lower',
    upper: 'Upper',
    reference: 'Reference',
    verdict: 'Verdict',
    reason: 'Reason',
    recordedBy: 'Recorded by',
    at: 'Time',
    findingNo: 'Finding',
    title: 'Title',
    priority: 'Priority',
    disposition: 'Disposition',
    status: 'Status',
    jobNo: 'Job',
    trade: 'Trade',
    quantity: 'Qty',
    origin: 'Origin',
    progress: 'Progress',
    approval: 'Approval',
    execution: 'Execution',
    verification: 'Verification',
    inspectionNo: 'Inspection',
    carriedTo: 'Carried to',
    step: 'Checkpoint',
    file: 'File',
    size: 'Size',
    open: 'Open',
  },
  status: {
    approved: 'Approved',
    in_progress: 'In Progress',
    completed: 'Completed',
    verified: 'Verified',
    closed: 'Closed',
    pending: 'Pending',
  },
  values: {
    attachmentCaption: '{{no}} · {{name}}',
    voided: 'Voided',
    notEmbedded: 'Not embedded; open the file',
    openLink: 'Open file (office sign-in)',
    openInApp: 'Open in Felixmate: inspection, checkpoint {{no}}',
    notReviewed: 'Not reviewed',
    selfReview: 'Self-review',
    additional: 'Additional job',
    carriedFrom: 'Carried from {{job}}',
    carriedTo: 'Carried to {{job}} ({{project}})',
    changed: 'Changed since office approval',
    provisional: 'Started before office approval',
    percent: '{{percent}}%',
    reviewStep: 'Review · {{code}}',
    decisionStep: '{{decision}} · {{no}}',
    verificationStep: 'Verification · {{no}}',
    reauthenticated: 'Password re-entered',
    libraryVersion: '{{label}} (version {{version}})',
    hash: 'Report content hash (SHA-256): {{hash}}',
    hashNote:
      'Computed from the records in the report, not from the print time: the same records always give the same hash.',
    planClose: 'Will be closed: {{list}}',
    planPending: 'Will remain Pending: {{list}}',
    planAlreadyPending: 'Already Pending: {{list}}',
    planUntouched: 'Not approved, not started (unchanged): {{list}}',
    openInspections: 'Open inspections (close them first): {{list}}',
    awaitingVerification: 'Awaiting office verification: {{list}}',
    verdicts: { verified: 'Verified', returned: 'Returned' },
    decisions: { approved: 'Approved', returned: 'Returned', rejected: 'Rejected' },
  },
  none: {
    attachments: 'No evidence attached.',
    results: 'No checkpoint.',
    measurements: 'No measurement recorded.',
    corrections: 'No correction.',
    findings: 'No finding.',
    jobs: 'No job.',
    pending: 'No pending job.',
    openFindings: 'All findings are closed.',
    inspections: 'No inspection.',
  },
  actions: {
    pdi: 'Inspection Report',
    jobList: 'Yard Job List PDF',
    closeout: 'Closeout Report',
    download: 'Download Closeout Report',
    save: 'Save PDF',
    print: 'Print',
  },
  failed: 'The report could not be created.',
};

export const drydockReportTr: typeof drydockReportEn = {
  pdiTitle: 'Havuz Öncesi Denetim Raporu',
  afterTitle: 'Havuz Sonrası Denetim Raporu',
  jobListTitle: 'Tersane İş Listesi',
  closeoutTitle: 'Havuzlama Kapanış Raporu',
  marks: {
    provisional: 'DENETİM AÇIK – GEÇİCİ',
    cancelled: 'İPTAL EDİLDİ',
    notApproved: 'ONAYLANMADI',
    containsNotApproved: 'ONAYLANMAMIŞ İŞ İÇERİR',
    preview: 'ÖNİZLEME – PROJE KAPANMADI',
  },
  sections: {
    general: 'Genel bilgiler',
    summary: 'Özet',
    results: 'Kontrol noktası sonuçları',
    measurements: 'Ölçümler',
    corrections: 'Düzeltmeler (revizyonlar)',
    findings: 'Bulgular',
    attachments: 'Kanıtlar',
    jobs: 'İşler',
    cancelledJobs: 'İptal edilen işler',
    inspections: 'Denetimler',
    pending: 'Bekleyen ve taşınan işler',
    openFindings: 'Kapanmamış bulgular',
    plan: 'Kapanış önizlemesi',
    review: 'İnceleme',
    approval: 'Ofis onayı',
    verification: 'Ofis doğrulaması',
  },
  fields: {
    vessel: 'Gemi',
    project: 'Proje',
    inspection: 'Denetim',
    kind: 'Tür',
    openedOn: 'Açılış',
    closedOn: 'Kapanış',
    library: 'Kütüphane sürümü',
    status: 'Durum',
    applicable: 'Uygulanan',
    inspected: 'Denetlenen',
    remaining: 'Kalan',
    adverse: 'Olumsuz',
    deferred: 'Havuz sonrası',
    notApplicable: 'Uygulanmaz',
    progress: 'İlerleme',
    yard: 'Tersane',
    dockedOn: 'Havuza giriş',
    undockedOn: 'Havuzdan çıkış',
    closeNote: 'Kapanış notu',
    jobs: 'İşler',
    approvedJobs: 'Onaylanan',
    findings: 'Bulgular',
    closedFindings: 'Kapanan bulgu',
    closedJobs: 'Kapanan iş',
    pendingJobs: 'Bekleyen iş',
    verifiedJobs: 'Doğrulanan iş',
  },
  columns: {
    code: 'Kimlik',
    checkpoint: 'Kontrol noktası',
    result: 'Sonuç',
    access: 'Erişim',
    inspector: 'Denetçi',
    inspected: 'Denetim zamanı',
    revision: 'Rev.',
    review: 'İnceleme',
    measurement: 'Ölçüm',
    value: 'Değer',
    lower: 'Alt',
    upper: 'Üst',
    reference: 'Referans',
    verdict: 'Karar',
    reason: 'Gerekçe',
    recordedBy: 'Kaydeden',
    at: 'Zaman',
    findingNo: 'Bulgu',
    title: 'Başlık',
    priority: 'Öncelik',
    disposition: 'Karar yolu',
    status: 'Durum',
    jobNo: 'İş',
    trade: 'İş kolu',
    quantity: 'Miktar',
    origin: 'Kaynak',
    progress: 'İlerleme',
    approval: 'Onay',
    execution: 'Uygulama',
    verification: 'Doğrulama',
    inspectionNo: 'Denetim',
    carriedTo: 'Taşındığı yer',
    step: 'Kontrol noktası',
    file: 'Dosya',
    size: 'Boyut',
    open: 'Aç',
  },
  status: {
    approved: 'Onaylandı',
    in_progress: 'Sürüyor',
    completed: 'Tamamlandı',
    verified: 'Doğrulandı',
    closed: 'Kapandı',
    pending: 'Bekliyor',
  },
  values: {
    attachmentCaption: '{{no}} · {{name}}',
    voided: 'İptal edildi',
    notEmbedded: 'Gömülmedi; dosyayı açın',
    openLink: 'Dosyayı aç (ofis girişi)',
    openInApp: "Felixmate'da açın: denetim, {{no}} kontrol noktası",
    notReviewed: 'İncelenmedi',
    selfReview: 'Kendi incelemesi',
    additional: 'Ek iş',
    carriedFrom: '{{job}} işinden taşındı',
    carriedTo: '{{job}} işine taşındı ({{project}})',
    changed: 'Ofis onayından sonra değişti',
    provisional: 'Ofis onayından önce başladı',
    percent: '%{{percent}}',
    reviewStep: 'İnceleme · {{code}}',
    decisionStep: '{{decision}} · {{no}}',
    verificationStep: 'Doğrulama · {{no}}',
    reauthenticated: 'Parola yeniden girildi',
    libraryVersion: '{{label}} ({{version}}. sürüm)',
    hash: 'Rapor içeriğinin özeti (SHA-256): {{hash}}',
    hashNote:
      'Basım zamanından değil, rapordaki kayıtlardan hesaplanır: aynı kayıtlar her zaman aynı özeti verir.',
    planClose: 'Kapanacak: {{list}}',
    planPending: 'Bekleyen kalacak: {{list}}',
    planAlreadyPending: 'Zaten bekleyen: {{list}}',
    planUntouched: 'Onaylanmamış, başlamamış (değişmez): {{list}}',
    openInspections: 'Açık denetimler (önce kapatın): {{list}}',
    awaitingVerification: 'Ofis doğrulaması bekleyen: {{list}}',
    verdicts: { verified: 'Doğrulandı', returned: 'İade edildi' },
    decisions: { approved: 'Onaylandı', returned: 'İade edildi', rejected: 'Reddedildi' },
  },
  none: {
    attachments: 'Kanıt eklenmedi.',
    results: 'Kontrol noktası yok.',
    measurements: 'Ölçüm kaydedilmedi.',
    corrections: 'Düzeltme yok.',
    findings: 'Bulgu yok.',
    jobs: 'İş yok.',
    pending: 'Bekleyen iş yok.',
    openFindings: 'Bütün bulgular kapandı.',
    inspections: 'Denetim yok.',
  },
  actions: {
    pdi: 'Denetim raporu',
    jobList: 'Tersane iş listesi PDF',
    closeout: 'Kapanış raporu',
    download: 'Kapanış raporunu indir',
    save: 'PDF kaydet',
    print: 'Yazdır',
  },
  failed: 'Rapor oluşturulamadı.',
};

/** Projenin denetim izi (Excel Screen 12, R7, R17). */
export const drydockAuditEn = {
  title: 'Audit Trail · {{no}}',
  open: 'Audit Trail',
  hint: 'Every change to the project, its inspections, findings and jobs: who, when (LT and UTC) and what. Records are never deleted; corrections and cancellations are kept with their reason.',
  error: 'The audit trail could not be loaded.',
  empty: 'No entry for this filter.',
  filter: 'Show',
  all: 'All',
  groups: {
    project: 'Project',
    inspection: 'Inspection',
    findings: 'Findings',
    jobs: 'Jobs',
    yard: 'Yard progress',
    office: 'Office decisions',
  },
  columns: { at: 'Time', record: 'Record', event: 'Event', by: 'By', note: 'Note' },
  sides: { ship: 'Vessel', office: 'Office' },
  marks: {
    selfReview: 'Self-review',
    reauthenticated: 'Password re-entered',
    provisional: 'Before office approval',
  },
  fields: 'Changed: {{list}}',
  percent: '{{percent}}%',
  kinds: {
    project_created: 'Project created',
    project_edited: 'Project edited',
    docked_in: 'Docked in',
    undocked: 'Undocked',
    project_closed: 'Project closed',
    project_cancelled: 'Project cancelled',
    inspection_opened: 'Inspection opened',
    inspection_edited: 'Inspection edited',
    result_recorded: 'Result recorded',
    result_corrected: 'Result corrected (new revision)',
    evidence_added: 'Evidence attached',
    evidence_voided: 'Evidence voided',
    result_reviewed: 'Result reviewed',
    inspection_closed: 'Inspection closed',
    inspection_cancelled: 'Inspection cancelled',
    finding_created: 'Finding created',
    finding_edited: 'Finding edited',
    finding_reviewed: 'Finding reviewed',
    finding_cancelled: 'Finding cancelled',
    job_created: 'Job created',
    job_edited: 'Job edited',
    link_added: 'Link added',
    link_voided: 'Link removed',
    job_submitted: 'Submitted to office',
    job_approved: 'Approved by office',
    job_returned: 'Returned by office',
    job_rejected: 'Rejected by office',
    job_cancelled: 'Job cancelled',
    job_started: 'Job started',
    job_progress: 'Progress updated',
    job_completed: 'Job completed',
    job_not_done: 'Job not done',
    job_verified: 'Verified by office',
    job_verification_returned: 'Returned for rework',
    job_closed: 'Job closed',
    job_pending: 'Job pending',
    finding_closed: 'Finding closed',
    finding_closure_verified: 'Finding closure verified',
    finding_closure_returned: 'Finding closure returned',
    finding_reopened: 'Finding reopened',
  },
};

export const drydockAuditTr: typeof drydockAuditEn = {
  title: 'Denetim izi · {{no}}',
  open: 'Denetim izi',
  hint: 'Projede, denetimlerinde, bulgularında ve işlerinde yapılan her değişiklik: kim, ne zaman (LT ve UTC), ne. Kayıt silinmez; düzeltme ve iptaller gerekçesiyle kalır.',
  error: 'Denetim izi yüklenemedi.',
  empty: 'Bu süzgeçte kayıt yok.',
  filter: 'Göster',
  all: 'Tümü',
  groups: {
    project: 'Proje',
    inspection: 'Denetim',
    findings: 'Bulgular',
    jobs: 'İşler',
    yard: 'Tersane ilerlemesi',
    office: 'Ofis kararları',
  },
  columns: { at: 'Zaman', record: 'Kayıt', event: 'Olay', by: 'Kişi', note: 'Not' },
  sides: { ship: 'Gemi', office: 'Ofis' },
  marks: {
    selfReview: 'Kendi incelemesi',
    reauthenticated: 'Parola yeniden girildi',
    provisional: 'Ofis onayından önce',
  },
  fields: 'Değişen: {{list}}',
  percent: '%{{percent}}',
  kinds: {
    project_created: 'Proje oluşturuldu',
    project_edited: 'Proje düzenlendi',
    docked_in: 'Havuza girdi',
    undocked: 'Havuzdan çıktı',
    project_closed: 'Proje kapandı',
    project_cancelled: 'Proje iptal edildi',
    inspection_opened: 'Denetim açıldı',
    inspection_edited: 'Denetim düzenlendi',
    result_recorded: 'Sonuç kaydedildi',
    result_corrected: 'Sonuç düzeltildi (yeni revizyon)',
    evidence_added: 'Kanıt eklendi',
    evidence_voided: 'Kanıt iptal edildi',
    result_reviewed: 'Sonuç incelendi',
    inspection_closed: 'Denetim kapandı',
    inspection_cancelled: 'Denetim iptal edildi',
    finding_created: 'Bulgu açıldı',
    finding_edited: 'Bulgu düzenlendi',
    finding_reviewed: 'Bulgu incelendi',
    finding_cancelled: 'Bulgu iptal edildi',
    job_created: 'İş açıldı',
    job_edited: 'İş düzenlendi',
    link_added: 'Bağ eklendi',
    link_voided: 'Bağ kaldırıldı',
    job_submitted: 'Ofise gönderildi',
    job_approved: 'Ofis onayladı',
    job_returned: 'Ofis iade etti',
    job_rejected: 'Ofis reddetti',
    job_cancelled: 'İş iptal edildi',
    job_started: 'İş başladı',
    job_progress: 'İlerleme güncellendi',
    job_completed: 'İş tamamlandı',
    job_not_done: 'İş yapılamadı',
    job_verified: 'Ofis doğruladı',
    job_verification_returned: 'Yeniden işe iade edildi',
    job_closed: 'İş kapandı',
    job_pending: 'İş beklemede',
    finding_closed: 'Bulgu kapandı',
    finding_closure_verified: 'Bulgu kapanışı doğrulandı',
    finding_closure_returned: 'Bulgu kapanışı iade edildi',
    finding_reopened: 'Bulgu yeniden açıldı',
  },
};

/** Ofisin filo görünümü (Maintenance (PMS) ▸ Dry Docking ▸ Fleet Overview). */
export const drydockFleetEn = {
  title: 'Dry Docking Fleet Overview',
  description:
    'Dry docking projects of the fleet: inspection progress, jobs awaiting the office, yard progress and verification. Vessel data is read-only in the office.',
  error: 'The fleet overview could not be loaded.',
  empty: 'No dry docking project in the fleet yet.',
  vessel: 'Vessel',
  allVessels: 'All vessels',
  stats: {
    active: 'Active projects',
    awaiting: 'Jobs awaiting office',
    inYard: 'In yard',
    verification: 'Awaiting verification',
  },
  columns: {
    vessel: 'Vessel',
    project: 'Project',
    state: 'Status',
    planned: 'Planned',
    inspection: 'Inspection',
    jobs: 'Jobs',
    awaiting: 'Awaiting office',
    inProgress: 'In progress',
    verification: 'Awaiting verification',
    pending: 'Pending',
  },
  open: 'Open',
  showCompleted: 'Show completed and cancelled',
};

export const drydockFleetTr: typeof drydockFleetEn = {
  title: 'Havuzlama filo görünümü',
  description:
    'Filonun havuzlama projeleri: denetim ilerlemesi, ofiste bekleyen işler, tersane ilerlemesi ve doğrulama. Gemi verisi ofiste salt okunurdur.',
  error: 'Filo görünümü yüklenemedi.',
  empty: 'Filoda henüz havuzlama projesi yok.',
  vessel: 'Gemi',
  allVessels: 'Bütün gemiler',
  stats: {
    active: 'Etkin proje',
    awaiting: 'Ofiste bekleyen iş',
    inYard: 'Tersanede',
    verification: 'Doğrulama bekleyen',
  },
  columns: {
    vessel: 'Gemi',
    project: 'Proje',
    state: 'Durum',
    planned: 'Plan',
    inspection: 'Denetim',
    jobs: 'İşler',
    awaiting: 'Ofiste bekleyen',
    inProgress: 'Süren',
    verification: 'Doğrulama bekleyen',
    pending: 'Bekleyen',
  },
  open: 'Aç',
  showCompleted: 'Tamamlanan ve iptal edilenleri göster',
};
